import { render } from "./AssignProductsModal.vue?vue&type=template&id=9b37d046&ts=true"
import script from "./AssignProductsModal.vue?vue&type=script&lang=ts"
export * from "./AssignProductsModal.vue?vue&type=script&lang=ts"

import "./AssignProductsModal.vue?vue&type=style&index=0&id=9b37d046&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__